import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { TimeSlotCardTimeSlotFragmentDoc } from './TimeSlotCard.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchAvailableTimeSlotQueryVariables = Types.Exact<{
  from: Types.Scalars['Time']['input'];
  until: Types.Scalars['Time']['input'];
}>;


export type FetchAvailableTimeSlotQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', availableTimeSlots: Array<{ __typename?: 'TimeSlot', startsAt: TimeString, endsAt: TimeString }> } };

export type TimeSlotPickerModalTimeSlotFragment = { __typename?: 'TimeSlot', startsAt: TimeString, endsAt: TimeString };

export type TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables = Types.Exact<{
  from: Types.Scalars['Time']['input'];
  until: Types.Scalars['Time']['input'];
}>;


export type TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery = { __typename?: 'Query', availableBookingRequestTimeSlots: { __typename: 'AvailableBookingRequestTimeSlotsErrorInvalidCalendarConnection', message: string } | { __typename: 'AvailableBookingRequestTimeSlotsErrorNoCalendarConnected', message: string } | { __typename: 'AvailableBookingRequestTimeSlotsSuccess', timeSlots: Array<{ __typename?: 'BookingRequestTimeSlot', startsAt: TimeString, endsAt: TimeString }> } };

export const TimeSlotPickerModalTimeSlotFragmentDoc = gql`
    fragment TimeSlotPickerModalTimeSlot on TimeSlot {
  ...TimeSlotCardTimeSlot
}
    ${TimeSlotCardTimeSlotFragmentDoc}`;
export const FetchAvailableTimeSlotDocument = gql`
    query fetchAvailableTimeSlot($from: Time!, $until: Time!) {
  viewer {
    availableTimeSlots(from: $from, until: $until) {
      ...TimeSlotCardTimeSlot
    }
  }
}
    ${TimeSlotCardTimeSlotFragmentDoc}`;

/**
 * __useFetchAvailableTimeSlotQuery__
 *
 * To run a query within a Vue component, call `useFetchAvailableTimeSlotQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAvailableTimeSlotQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchAvailableTimeSlotQuery({
 *   from: // value for 'from'
 *   until: // value for 'until'
 * });
 */
export function useFetchAvailableTimeSlotQuery(variables: FetchAvailableTimeSlotQueryVariables | VueCompositionApi.Ref<FetchAvailableTimeSlotQueryVariables> | ReactiveFunction<FetchAvailableTimeSlotQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables>(FetchAvailableTimeSlotDocument, variables, options);
}
export function useFetchAvailableTimeSlotLazyQuery(variables?: FetchAvailableTimeSlotQueryVariables | VueCompositionApi.Ref<FetchAvailableTimeSlotQueryVariables> | ReactiveFunction<FetchAvailableTimeSlotQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables>(FetchAvailableTimeSlotDocument, variables, options);
}
export type FetchAvailableTimeSlotQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchAvailableTimeSlotQuery, FetchAvailableTimeSlotQueryVariables>;
export const TimeSlotPickerModalAvailableBookingRequestTimeSlotsDocument = gql`
    query TimeSlotPickerModalAvailableBookingRequestTimeSlots($from: Time!, $until: Time!) {
  availableBookingRequestTimeSlots(from: $from, until: $until) {
    __typename
    ... on AvailableBookingRequestTimeSlotsSuccess {
      timeSlots {
        startsAt
        endsAt
      }
    }
    ... on AvailableBookingRequestTimeSlotsErrorNoCalendarConnected {
      message
    }
    ... on AvailableBookingRequestTimeSlotsErrorInvalidCalendarConnection {
      message
    }
  }
}
    `;

/**
 * __useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery__
 *
 * To run a query within a Vue component, call `useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery({
 *   from: // value for 'from'
 *   until: // value for 'until'
 * });
 */
export function useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery(variables: TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables | VueCompositionApi.Ref<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables> | ReactiveFunction<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>(TimeSlotPickerModalAvailableBookingRequestTimeSlotsDocument, variables, options);
}
export function useTimeSlotPickerModalAvailableBookingRequestTimeSlotsLazyQuery(variables?: TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables | VueCompositionApi.Ref<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables> | ReactiveFunction<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>(TimeSlotPickerModalAvailableBookingRequestTimeSlotsDocument, variables, options);
}
export type TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>;